import {
  Group,
  NumberFormatter,
  Skeleton,
  Stack,
  Text,
  Title,
  useMantineTheme,
} from '@mantine/core';
import { IconChartPie4 } from '@tabler/icons-react';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { Ticker } from 'components/Ticker';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadDebtorBalance } from 'shared/hooks/use-load-debtor-balance';
import { getCurrencySymbolFromCurrencyCode } from 'shared/utils/currency';
import { computeDebtorBalance } from '../../BalanceTab/ComputeDebtorBalance';

export const TurnoverInfoPanel = () => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const debtor = useDebtor();
  const company = useCompanyConfiguration();

  const { debtorBalance, isDebtorBalanceInitialLoading, debtorBalanceError } = useLoadDebtorBalance(
    String(debtor.id),
    true,
  );

  if (debtorBalanceError)
    return (
      <Ticker
        title={t(i18nKeys.CLIENT.GENERAL_INFO_TAB.ANNUAL_TURNOVER_SHARE).toUpperCase()}
        h="100%"
        topRight={<IconChartPie4 size={18} color={theme.colors.gray[6]} />}
      >
        <Text size="sm" c="dimmed">
          {t(i18nKeys.CLIENT.GENERAL_INFO_TAB.COULD_NOT_FETCH)}
        </Text>
      </Ticker>
    );

  if (isDebtorBalanceInitialLoading)
    return (
      <Ticker
        title={t(i18nKeys.CLIENT.GENERAL_INFO_TAB.ANNUAL_TURNOVER_SHARE).toUpperCase()}
        h="100%"
        topRight={<IconChartPie4 size={18} color={theme.colors.gray[6]} />}
      >
        <Stack gap={4}>
          <Skeleton height={30} width={100} />
          <Skeleton height={18} width={120} />
        </Stack>
      </Ticker>
    );

  if (!debtorBalance) return null;

  const { annualTurnover } = computeDebtorBalance(debtorBalance);

  // annualTurnover does not count late fees, add a tooltip ?
  return (
    <Ticker
      title={t(i18nKeys.CLIENT.GENERAL_INFO_TAB.ANNUAL_TURNOVER_SHARE).toUpperCase()}
      topRight={<IconChartPie4 size={18} color={theme.colors.gray[6]} />}
    >
      <Stack gap={0}>
        <Group gap={4} align="end">
          <Title order={4}>
            <NumberFormatter decimalScale={2} value={debtor.annual_turnover_share * 100} />
          </Title>
          <Text>%</Text>
        </Group>
        <Group gap={6}>
          <Text c="dimmed" size="sm">
            <NumberFormatter
              value={annualTurnover}
              suffix={`${getCurrencySymbolFromCurrencyCode(company.currency)}`}
              decimalScale={2}
              thousandSeparator=" "
            />
          </Text>
          <Text size="sm" c="dimmed">
            {t(i18nKeys.CLIENT.GENERAL_INFO_TAB.BILLED_AMOUNT_SUFFIX)}
          </Text>
        </Group>
      </Stack>
    </Ticker>
  );
};
